import Input, { Checkbox, DateInput } from "../../ui/Input/Input";

export default function FilterRow({ filterObj = {}, handleChange, handleSelectAll, selected }) {

    return (
        <tr className="filter_table_row">
            <td className="check_cell" onClick={handleSelectAll}>
                <Checkbox checked={selected} onChange={handleSelectAll} onClick={e => e.stopPropagation()} />
            </td>
            {Object.entries(filterObj).map(([key, value]) => key !== 'createdAt' ?
                (
                    <td key={key}>
                        <Input type="text" placeholder={`${key}...`} onChange={({ target }) => handleChange(key, target.value)} value={value} />
                    </td>
                ) :
                (
                    <td key={key}>
                        <DateInput allowClear={true} placeholder={`${key}...`} onChange={(_, date) => handleChange(key, date)} value={value} />
                    </td>
                )
            )}
        </tr>
    )
}
